import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, pyrotchBaseUrl } from '../axios/AxiosInstance';

interface Task {
  id: number;
  summary: string;
  description: string;
  key: string;
  sequence: number;
  taskStatus: string;
  taskIssueType: string;
  projectId: number;
  userId: number | null;
  milestoneId: number | null;
}

interface timeLog {
  taskId: number;
  description: string;
  startDate: string;
} 

interface TaskDetails {
  id: number,
  summary: string,
  description: string,
  taskStatus: string,
  userId: number,
  projectMilestoneId: number,
  // startDate: string,
  onHoldComment: string,
  approvalComment: string,
}

interface projectMilestones {
  name: string;
  milestoneId: number;
}

interface projectUser {
  userId : number;
  userName: string;
}

interface ReorderTasksRequest {
  projectId: number;
  requestBody: Array<{
    taskId: number;
    newSequence: number;
    status: string;
  }>;
}

interface timeLogs {
  id: number;
  userId: number;
  userName: string;
  taskId: number;
  logDate: string;
  timeSpent: string;
  description: string;
}

interface TimeLogsResponse {
  number: number;
  numberOfElements: number;
  timeLogs: timeLogs[];
  totalTime: string;
  hasPrevious: boolean;
  hasNext: boolean;
  currentPage: number;
}

export const BoardApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl, // Your base URL
  }),
  reducerPath: 'boardApi',
  tagTypes: ['Task'],
  endpoints: (build) => ({
    createProjectTask: build.mutation({
      query: (taskData) => ({
        url: 'v1/project-task/add', 
        method: 'POST',     
        data: taskData,   
      }),
    }),

    // fetchProjectTask: build.query<{ projectTasks: Task[], projectMilestones: projectMilestones[], projectUser: projectUser[] }, number>({
    //   query: (projectId) => ({
    //     url: `v1/project-task/tasks/${projectId}`
    //   }),
    //   providesTags: ['Task'],
    // }),

    reorderTasks: build.mutation<any, ReorderTasksRequest>({
      query: ({ projectId, requestBody }) => ({
        url: `v1/project-task/${projectId}/tasks/reorder`, // Use the projectId dynamically
        method: 'PUT',
        data: requestBody,
      }),
    }),
    
    deleteTasks: build.mutation<void, number>({
      query: (taskId) => ({
        url: `v1/project-task/${taskId}`, // Use the taskId dynamically
        method: 'DELETE',
      }),
      invalidatesTags: ['Task'],
    }),

    getProjectTask: build.query<any, { taskId: number; projectId: number }>({
      query: ({ taskId, projectId }) => ({
        url: `v1/project-task/tasks/${taskId}/project/${projectId}`,
        method: 'GET',
      }),
    }),

    addTaskDetails: build.mutation<any, TaskDetails>({
      query: (taskDetails) => ({
        url: `v1/project-task/tasks`,
        method: 'PUT',
        data: taskDetails,
      }),
    }),

    addTimeLog: build.mutation<any, timeLog>({
      query: ({ taskId, description, startDate}) => ({
        url: `v1/project-task/tasks/${taskId}/add-time-log`,
        method: 'POST',
        params: {description, startDate},
      }),
    }),

    getTimeLogs: build.query<TimeLogsResponse, { taskId: number; page?: number; size?: number }>({
      query: ({ taskId, page = 0, size = 10 }) => ({
        url: `v1/project-task/tasks/${taskId}/time-logs`,
        method: 'GET',
        params: { page, size },
      }),
    }),

    requestApproval : build.mutation<any, {projectId: number, taskId: number}>({
      query: ({projectId, taskId}) => ({
        url: `v1/project-task/${projectId}/task/${taskId}/request-approval`,
        method: 'POST',
        params: {projectId, taskId},
      })
    }),

    approveDecline: build.mutation({
      query: ({taskId, isApproved, declineComment }) => ({
        url: `v1/project-task/${taskId}/approve-Decline`,
        method: 'POST',
        params: {taskId, isApproved, declineComment},
      })
    }),

    searchTask : build.mutation<any, {projectId: number, page: number, size: number,searchString: string }>({
      query: ({projectId, page, size, searchString}) => ({
        url: `v2/project-task/tasks/${projectId}`,
        method: 'POST',
        data: {page, size, searchString},
      })
    })
  }),
});

export const { useCreateProjectTaskMutation, useReorderTasksMutation, useDeleteTasksMutation, useGetProjectTaskQuery, useAddTaskDetailsMutation, useAddTimeLogMutation, useGetTimeLogsQuery, useRequestApprovalMutation, useApproveDeclineMutation, useSearchTaskMutation } = BoardApi;